"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UInt64_1 = require("../UInt64");
const MosaicLevyType_1 = require("./MosaicLevyType");
class MosaicLevy {
    constructor(type, recipient, mosaicId, fee) {
        this.type = type;
        this.recipient = recipient;
        this.mosaicId = mosaicId;
        this.fee = fee;
    }
    static createWithPercentageFee(recipient, mosaicId, percentage) {
        if (percentage > 100) {
            throw new Error("Percentage cannot be more than 100%");
        }
        else if (percentage < 0.00001) {
            throw new Error("Percentage cannot be less than 0.00001%");
        }
        return new MosaicLevy(MosaicLevyType_1.MosaicLevyType.LevyPercentileFee, recipient, mosaicId, MosaicLevy.createLevyFeePercentile(percentage));
    }
    static createWithAbsoluteFee(recipient, mosaicId, amount) {
        return new MosaicLevy(MosaicLevyType_1.MosaicLevyType.LevyAbsoluteFee, recipient, mosaicId, UInt64_1.UInt64.fromUint(amount));
    }
    static createLevyFeePercentile(percentage) {
        return UInt64_1.UInt64.fromUint(percentage * MosaicLevy.DefaultMosaicLevyEffectiveValue);
    }
}
exports.MosaicLevy = MosaicLevy;
/**
 * default amount that Levy fee will be effective, represent 1%
 */
MosaicLevy.DefaultMosaicLevyEffectiveValue = 100000;
//# sourceMappingURL=MosaicLevy.js.map